import { render, staticRenderFns } from "./seriesStatisticsTab.vue?vue&type=template&id=2edff83c&scoped=true"
import script from "./seriesStatisticsTab.vue?vue&type=script&lang=js"
export * from "./seriesStatisticsTab.vue?vue&type=script&lang=js"
import style0 from "./seriesStatisticsTab.vue?vue&type=style&index=0&id=2edff83c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2edff83c",
  null
  
)

export default component.exports